import {
    Close,
    StickyNote2Outlined,
    Restore,
    BookmarkAddOutlined,
    NotificationsOutlined,
  } from "@mui/icons-material";
  import { Drawer, Box, Typography, Divider } from "@mui/material";
  
  interface MMenuDrawerProps {
    isOpen: boolean;
    handleClose?: () => void;
  }
  function MMenuDrawer({ isOpen, handleClose }: MMenuDrawerProps) {
    return (
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={handleClose}
        PaperProps={{
          sx: { width: "75%" },
        }}
      >
        <Box display="flex" flexDirection="column" p={2} position="relative">
          <Box position="fixed" top="10px" right="10px" onClick={handleClose}>
            <Close fontSize="large" />
          </Box>
          <Box display="flex" flexDirection="column" color="#af9b65">
            <Typography variant="h6" fontWeight="bold" my={1}>
              ログイン
            </Typography>
            <Typography variant="h6" fontWeight="bold" my={1}>
              会員登録
            </Typography>
          </Box>
  
          <Box color="#af9b65" my={1}>
            <Box display="flex" my={2}>
              <StickyNote2Outlined sx={{ mx: 1 }} />
              <Typography color="black" fontWeight="bold">
                予約確認・変更
              </Typography>
            </Box>
            <Box display="flex" my={2}>
              <Restore sx={{ mx: 1 }} />
              <Typography color="black" fontWeight="bold">
                最近見たレストラン
              </Typography>
            </Box>
            <Box display="flex" my={2}>
              <BookmarkAddOutlined sx={{ mx: 1 }} />
              <Typography color="black" fontWeight="bold">
                お気に入り
              </Typography>
            </Box>
            <Box display="flex" my={2}>
              <NotificationsOutlined sx={{ mx: 1 }} />
              <Typography color="black" fontWeight="bold">
                空席通知
              </Typography>
            </Box>
          </Box>
  
          <Divider />
  
          <Box my={2} px={1}>
            <Typography fontWeight="bold" my={2}>
              サポート
            </Typography>
            <Typography variant="subtitle2" my={2}>
              ヘルプ・お問い合わせ
            </Typography>
            <Typography variant="subtitle2" my={2}>
              個人情報保護方針
            </Typography>
            <Typography variant="subtitle2" my={2}>
              規約集
            </Typography>
            <Typography variant="subtitle2" my={2}>
              企業情報
            </Typography>
          </Box>
  
          <Divider />
  
          <Box my={2} px={1}>
            <Typography fontWeight="bold" my={2}>
              サービス
            </Typography>
            <Typography variant="subtitle2" my={2}>
              国内宿泊予約
            </Typography>
            <Typography variant="subtitle2" my={2}>
              個人情報保護方針
            </Typography>
            <Typography variant="subtitle2" my={2}>
              ギフト
            </Typography>
            <Typography variant="subtitle2" my={2}>
              海外宿泊予約
            </Typography>
            <Typography variant="subtitle2" my={2}>
              お取り寄せ
            </Typography>
            <Typography variant="subtitle2" my={2}>
              ふるさと納税
            </Typography>
          </Box>
        </Box>
      </Drawer>
    );
  }
  
  export default MMenuDrawer;
  